export default "__VITE_ASSET__5bae529c__"